import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { Alert, Button, CircularProgress, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircle";
import Layout from "../components/Layout";
import { uploadExcelForCourse } from "../service/service";
import { useAuthContext } from "../context/AuthContext";

const ExcelUploader = () => {
  const navigate = useNavigate();
  const { setUserManagedCourses } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errorDetails, setErrorDetails] = useState([]);
  const [course, setCourse] = useState(null);
  const [warnings, setWarnings] = useState([]);

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setLoading(true); setError(""); setErrorDetails([]); setCourse(null); setWarnings([]);
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      try {
        const workbook = XLSX.read(target.result, { type: "binary" });
        const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
        const courseName = file.name.replace(/\.[^.]+$/, "");
        const result = await uploadExcelForCourse({ courseName, excelData });
        if (!result.success) {
          const responseData = result.response?.data || result;
          setError(responseData.message || "Course creation failed.");
          setErrorDetails(responseData.data?.excelRowError || []);
          return;
        }
        setCourse({ id: result.data.courseId, name: courseName });
        setWarnings(result.data.excelRowError || []);
        setUserManagedCourses(result.data.courseId);
      } catch (uploadError) { setError(uploadError.message || "Course creation failed."); }
      finally { setLoading(false); }
    };
    reader.readAsBinaryString(file);
  };

  return <Layout><Stack spacing={2} sx={{ maxWidth: 680, mx: "auto", p: 3 }}>
    <Typography variant="h4">Create course from Excel</Typography>
    <Typography color="text.secondary">Audio is uploaded after the course exists, from its Audio & Voices tab. This keeps validation, Azure uploads, and saved audio URLs in one safe workflow.</Typography>
    <Button component="label" variant="outlined" disabled={loading}>Select Excel file<input hidden type="file" accept=".xlsx,.xls" onChange={handleFileUpload} /></Button>
    {loading && <Stack direction="row" spacing={1} alignItems="center"><CircularProgress size={22} /><Typography>Creating course…</Typography></Stack>}
    {error && <Alert severity="error">{error}{!!errorDetails.length && <ul>{errorDetails.map((detail) => <li key={detail}>{detail}</li>)}</ul>}</Alert>}
    {course && <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">{course.name} was created. Open Audio & Voices to add its course folder and configure characters.</Alert>}
    {!!warnings.length && <Alert severity="warning"><Typography variant="subtitle2">Course created with spreadsheet warnings</Typography><ul>{warnings.map((warning) => <li key={warning}>{warning}</li>)}</ul></Alert>}
    {course && <Stack direction="row" spacing={1}><Button variant="contained" onClick={() => navigate(`/edit/${course.id}?tab=audio`)}>Open Audio & Voices</Button><Button onClick={() => navigate(`/edit/${course.id}`)}>Edit course</Button></Stack>}
  </Stack></Layout>;
};
export default ExcelUploader;
